module.exports = __webpack_public_path__ + "static/hero-home-renovation-loan-4dbd568b0098b9aee5d07944b1738fcd.webp";